import { render, staticRenderFns } from "./FeedbackBox.vue?vue&type=template&id=11c43252&scoped=true&"
import script from "./FeedbackBox.vue?vue&type=script&lang=js&"
export * from "./FeedbackBox.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackBox.vue?vue&type=style&index=0&id=11c43252&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c43252",
  null
  
)

export default component.exports